import PromotionAction from '../../prat_actions/gt/promotionAction'

const PromotionReducer = (state = {isPromotionLoading: true,isPromotionLevelLoading:false,
isPromoCSVFileDownloading: false, promoCSVFileDownloadHasError: false,
calculateCSVPromoHasError:false, isCalculateCSVPromoloading:false, promoCSVData:undefined }, action ) => {
    switch (action.type) {
        case PromotionAction.PROMOTION_TYPE_REQUEST :
            return {
                ...state,
                isPromotionLoading:false,
            };

        case PromotionAction.PROMOTION_TYPE_SUCCESS :
            return {
                ...state,
                isPromotionLoading:false,
                promotionType: action.data
            };

        case PromotionAction.PROMOTION_TYPE_FAILED :
            return {
                ...state,
                isPromotionLoading:false,
                error:action.error
            };

        // PROMOTION LEVEL

        case PromotionAction.PROMOTION_LEVEL_REQUEST :
            return {
                ...state,
                isPromotionLoading:false,
                isPromotionLevelLoading:true
            };

        case PromotionAction.PROMOTION_LEVEL_SUCCESS :
            return {
                ...state,
                isPromotionLoading:false,
                promotionLevel: action.data,
                isPromotionLevelLoading:false
            };

        case PromotionAction.PROMOTION_LEVEL_FAILED :
            return {
                ...state,
                isPromotionLoading:false,
                error:action.error,
                isPromotionLevelLoading:false
            };

        // PRMOTION CSV FILE DOWNLOAD
    
        case PromotionAction.DOWNLOAD_PROMO_CSV_REQUEST:
        return {
            ...state,
            isPromoCSVFileDownloading: true,
            promoCSVFile:[],
            promoCSVFileDownloadHasError:false
        };
        case PromotionAction.DOWNLOAD_PROMO_CSV_SUCCESS:
        return {
            ...state,
            isPromoCSVFileDownloading: false,
            promoCSVFile: action.data.data,
            promoCSVFileDownloadHasError:false
        };
        case PromotionAction.DOWNLOAD_PROMO_CSV_FAILED:
        return {
            ...state,
            errorMessage: {},
            isPromoCSVFileDownloading: false,
            promoCSVFile:[],
            promoCSVFileDownloadHasError:true
        };

        // CALCULATE PREOSPO FROM CSV
    
        case PromotionAction.CALCULATE_PROMO_CSV_REQUEST:
        return {
            ...state,
            isCalculateCSVPromoloading: true,
            calculateCSVPromoHasError:false
        };
        case PromotionAction.CALCULATE_PROMO_CSV_SUCCESS:
        return {
            ...state,
            isCalculateCSVPromoloading: false,
            promoCSVData: action.data.data,
            calculateCSVPromoHasError:false
        };
        case PromotionAction.CALCULATE_PROMO_CSV_FAILED:
        return {
            ...state,
            errorMessage: {},
            isCalculateCSVPromoloading: false,
            promoCSVData:undefined,
            calculateCSVPromoHasError:true
        };

        default :
          return {
              ...state
          };
    }
}

export default PromotionReducer;